import React, { Component } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap';
import auth from '../../../auth/';
import api from '../../../api/';
import moment from 'moment';

import './Login.css';
import logoParadigma from '../../../../public/img/logoParadigma.png';
import logo from '../../../../public/img/logo.png';
import loader from '../../../../public/img/loader.gif';

const ERROR_CREDENCIALES = 'El usuario y/o contraseña son incorrectos.';
const ERROR_CODIGO = 'El código es incorrecto o venció.';

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			username: '',
			password: '',
			showPassword: false,
			showError: false,
			isLoading: false,
			// Proteccion anti fuerza bruta. El backend no las pide de entrada:
			// aparecen cuando alguien acumulo intentos fallidos (ver
			// users/services/services_antifuerzabruta.py).
			mensajeError: ERROR_CREDENCIALES,
			captcha: null,          // { key, imagen } del desafio a resolver
			captchaValue: '',
			segundosRestantes: 0,   // > 0 => bloqueado, con countdown
			// Segundo factor. `desafio` no es nulo solo cuando la contraseña ya
			// se valido y el backend esta esperando los 6 digitos del
			// autenticador: es lo que hace que la pantalla muestre un formulario
			// o el otro. No es una credencial de acceso — sirve unicamente para
			// ese canje y vence en minutos.
			desafio: null,
			codigo: '',
		}
		this.timer = null;
	}

	componentDidMount() {

	}

	componentWillUnmount() {
		// El countdown sigue corriendo si el usuario se va de la pantalla y
		// setState sobre un componente desmontado tira warning.
		this.detenerCountdown();
	}

	login = (e) => {
		e.preventDefault();
		if (this.state.segundosRestantes > 0) return;

		this.setState(_ => ({ isLoading: true }));

		const { username, password, captcha, captchaValue } = this.state;
		const desafio = captcha ? { key: captcha.key, value: captchaValue } : null;

		auth.login(username, password, desafio, response => {
			if (response.success) {
				this.props.history.push('/');
				return;
			}
			this.manejarError(response);
		});
	}

	/**
	 * Traduce la respuesta de error al estado del formulario.
	 *
	 * El 400 solo no alcanza para decidir: puede ser "credenciales
	 * incorrectas", "resolve este captcha", "ese captcha estaba mal" o
	 * "falta el codigo del autenticador", y lo que los separa es meta.codigo.
	 * El desafio del captcha siempre viene nuevo, porque el anterior quedo
	 * consumido del lado del backend.
	 *
	 * El caso del segundo factor es el unico que NO es un error de verdad: la
	 * contraseña estuvo bien y lo que falta es el segundo paso. Llega por el
	 * camino del error porque la respuesta es un 400 sin token, y es un 400
	 * justamente para que no se confunda con un login completo (ver
	 * SegundoFactorRequeridoJsonResult en el backend).
	 */
	manejarError = (error) => {
		const bloqueado = error.status === 429;

		if (error.segundoFactorRequerido && error.desafio) {
			this.pedirSegundoFactor(error);
			return;
		}

		this.setState(_ => ({
			isLoading: false,
			showError: true,
			mensajeError: error.mensaje || ERROR_CREDENCIALES,
			// Si no vino captcha nuevo pero sigue exigiendose, se conserva el
			// que estaba para no dejar el formulario sin imagen.
			captcha: error.captcha || (error.captchaRequerido ? this.state.captcha : null),
			captchaValue: '',
			segundosRestantes: bloqueado ? error.segundosRestantes : 0,
		}), () => {
			if (bloqueado) this.arrancarCountdown();
		});
	}

	/**
	 * Pasa al formulario del codigo del autenticador.
	 *
	 * La contraseña se borra del estado y no es cosmetico: ya cumplio su
	 * funcion, el backend no la vuelve a pedir en este flujo, y dejarla en
	 * memoria de la pantalla mientras la persona busca el telefono es tenerla
	 * de mas. El captcha tambien se limpia, porque el que haya quedado ya se
	 * consumio en el request que acaba de pasar.
	 */
	pedirSegundoFactor = (error) => {
		this.setState(_ => ({
			isLoading: false,
			showError: false,
			desafio: error.desafio,
			codigo: '',
			password: '',
			captcha: null,
			captchaValue: '',
		}));
	}

	/**
	 * Segundo paso: manda el codigo y entra.
	 *
	 * Ante un codigo errado se vuelve a /login completo (desafio en null) en vez
	 * de dejar reintentar en esta pantalla. Es lo que el backend ya decidio y
	 * la pantalla lo acompaña: el desafio tolera pocos intentos y se muere, asi
	 * que ofrecer un campo que despues de unos intentos deja de funcionar sin
	 * explicacion es peor que mandar a empezar de nuevo. El mensaje lo dice.
	 */
	verificarCodigo = (e) => {
		e.preventDefault();
		if (this.state.segundosRestantes > 0) return;

		this.setState(_ => ({ isLoading: true }));

		const { desafio, codigo } = this.state;

		auth.verificarSegundoFactor(desafio, codigo, response => {
			if (response.success) {
				this.props.history.push('/');
				return;
			}

			const bloqueado = response.status === 429;

			this.setState(_ => ({
				isLoading: false,
				showError: true,
				mensajeError: response.mensaje || ERROR_CODIGO,
				desafio: null,
				codigo: '',
				segundosRestantes: bloqueado ? response.segundosRestantes : 0,
			}), () => {
				if (bloqueado) this.arrancarCountdown();
			});
		});
	}

	/** Volver a empezar desde el usuario y la contraseña. */
	cancelarSegundoFactor = (e) => {
		e.preventDefault();
		this.setState(_ => ({
			desafio: null,
			codigo: '',
			password: '',
			showError: false,
		}));
	}

	arrancarCountdown = () => {
		this.detenerCountdown();
		this.timer = setInterval(() => {
			this.setState(prevState => {
				const restantes = prevState.segundosRestantes - 1;
				if (restantes > 0) return { segundosRestantes: restantes };
				// Se termino el bloqueo: se habilita el form de nuevo.
				this.detenerCountdown();
				return { segundosRestantes: 0, showError: false };
			});
		}, 1000);
	}

	detenerCountdown = () => {
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	}

	refrescarCaptcha = (e) => {
		e.preventDefault();
		auth.pedirCaptcha(this.state.username, captcha => {
			this.setState(_ => ({ captcha: captcha, captchaValue: '' }));
		});
	}

	onUsernameChange = e => {
		e.persist();
		this.setState(prevState => ({
			showError: false,
			username: e.target.value
		}));
	}

	onPasswordChange = e => {
		e.persist();
		this.setState(prevState => ({
			showError: false,
			password: e.target.value
		}));
	}

	onCaptchaChange = e => {
		e.persist();
		this.setState(prevState => ({
			showError: false,
			captchaValue: e.target.value
		}));
	}

	/**
	 * El codigo del autenticador, dejando solo digitos y cortado en 6.
	 *
	 * Los autenticadores muestran el codigo partido ('123 456') y copiarlo y
	 * pegarlo arrastra el espacio: sacarlo aca es lo que hace que pegar
	 * funcione. El backend tambien normaliza, asi que esto es comodidad y no la
	 * validacion — la validacion no puede vivir en el cliente.
	 */
	onCodigoChange = e => {
		e.persist();
		const limpio = e.target.value.replace(/\D/g, '').slice(0, 6);
		this.setState(prevState => ({
			showError: false,
			codigo: limpio
		}));
	}

	onShowPassword = e => {
		e.persist();
		this.setState(() => ({
			showPassword: e.type === 'mousedown'
		}));
	}

	/** "46 minutos" / "38 segundos": en minutos se lee mejor arriba del minuto. */
	textoEspera = () => {
		const segundos = this.state.segundosRestantes;
		if (segundos >= 60) {
			const minutos = Math.ceil(segundos / 60);
			return minutos === 1 ? '1 minuto' : minutos + ' minutos';
		}
		return segundos === 1 ? '1 segundo' : segundos + ' segundos';
	}

	/** El Alert de error, que es igual en los dos pasos del login. */
	renderError = (bloqueado) => {
		if (!this.state.showError) return null;

		return (
			<Alert color="danger">
				{
					bloqueado
						? 'Demasiados intentos fallidos. Vuelva a intentar en ' + this.textoEspera() + '.'
						: this.state.mensajeError
				}
			</Alert>
		);
	}

	/** Primer paso: usuario, contraseña y el captcha si el backend lo pidio. */
	renderFormCredenciales = (bloqueado) => {
		return (
			<Form
				onSubmit={this.login}
				autoComplete="off"
			>
				<FormGroup>
					<Label for="username">Nombre de usuario</Label>
					<Input
						id="username"
						type="text"
						autoComplete="off"
						value={this.state.username}
						onChange={this.onUsernameChange}
						disabled={bloqueado}
					/>
				</FormGroup>
				<FormGroup>
					<Label for="password">Contraseña</Label>
					<div className="password">
						<Input
							id="password"
							type={this.state.showPassword ? 'text' : 'password'}
							// Chrome y Edge ignoran el autoComplete en los campos de
							// password: el guardado de credenciales se deshabilita por
							// configuracion/politica del navegador, no desde aca.
							autoComplete="off"
							value={this.state.password}
							onChange={this.onPasswordChange}
							disabled={bloqueado}
						/>
						<Button
							onClick={e => e.preventDefault()}
							onMouseDown={this.onShowPassword}
							onMouseUp={this.onShowPassword}
							className="password__show-pw"
						>
							<i className={'fa ' + (!this.state.showPassword ? 'fa-eye' : 'fa-eye-slash')}></i>
						</Button>
					</div>

				</FormGroup>

				{
					this.state.captcha && !bloqueado &&
					<FormGroup>
						<Label for="captcha">Código de la imagen</Label>
						<div className="captcha">
							<img
								className="captcha__img"
								src={api.captchaImagen(this.state.captcha.imagen)}
								alt="Código de verificación"
							/>
							<Button
								onClick={this.refrescarCaptcha}
								className="captcha__refresh"
								title="Ver otra imagen"
							>
								<i className="fa fa-refresh"></i>
							</Button>
							<Input
								id="captcha"
								type="text"
								autoComplete="off"
								value={this.state.captchaValue}
								onChange={this.onCaptchaChange}
							/>
						</div>
					</FormGroup>
				}

				{this.renderError(bloqueado)}

				<div className="text-right">
					{
						this.state.isLoading &&
							<img className="mr-2" src={loader} alt="Espere..." />
					}
					<Button color="success" className="d-inline ml-auto " disabled={bloqueado}>
						{this.state.isLoading ? 'Iniciando sesión...' : 'Iniciar sesión'}
					</Button>
				</div>
			</Form>
		);
	}

	/**
	 * Segundo paso: los 6 dígitos del autenticador.
	 *
	 * Reemplaza al formulario de credenciales en vez de agregarse abajo. La
	 * contraseña ya se valido y el backend no la vuelve a pedir en este flujo,
	 * asi que dejar el campo en pantalla invitaria a tipearla de nuevo para
	 * nada; y el usuario no esta eligiendo entre dos cosas, esta en el paso
	 * siguiente de una sola.
	 *
	 * El input va con inputMode="numeric" y autoComplete="one-time-code": en el
	 * celular eso levanta el teclado numerico, y en iOS y en Chrome permite que
	 * el sistema ofrezca el codigo si lo detecto. Ninguna de las dos cosas es
	 * necesaria para que funcione.
	 */
	renderFormCodigo = (bloqueado) => {
		return (
			<Form
				onSubmit={this.verificarCodigo}
				autoComplete="off"
			>
				<FormGroup>
					<Label for="codigo">Código de verificación</Label>
					<Input
						id="codigo"
						type="text"
						inputMode="numeric"
						autoComplete="one-time-code"
						maxLength={6}
						autoFocus={true}
						value={this.state.codigo}
						onChange={this.onCodigoChange}
						disabled={bloqueado}
					/>
					<small className="text-muted d-block mt-1">
						Escriba el código de 6 dígitos que muestra su aplicación de
						autenticación.
					</small>
				</FormGroup>

				{this.renderError(bloqueado)}

				<div className="text-right">
					{
						this.state.isLoading &&
							<img className="mr-2" src={loader} alt="Espere..." />
					}
					<Button
						color="secondary"
						className="d-inline mr-2"
						onClick={this.cancelarSegundoFactor}
						disabled={this.state.isLoading}
					>Cancelar</Button>
					<Button
						color="success"
						className="d-inline ml-auto "
						disabled={bloqueado || this.state.codigo.length !== 6}
					>
						{this.state.isLoading ? 'Verificando...' : 'Verificar'}
					</Button>
				</div>
			</Form>
		);
	}

	render() {
		const bloqueado = this.state.segundosRestantes > 0;
		// El desafio es lo unico que define en que paso esta la pantalla: existe
		// solo entre que el backend valido la contraseña y que el codigo se
		// canjea por una sesion.
		const esperandoCodigo = !!this.state.desafio;

		return (
			<div className="login-page w-100 h-100 position-absolute">
				<Container className="d-flex flex-column justify-content-center h-100" >
					<Row className="justify-content-center px-3 px-md-0">
						<Col xs="12" lg="6" xl="5" className="login-form px-4 py-5 px-md-5 cont_login">
							<div className="logo-paradigma text-center">
								<img src={logo} alt="Logo de la empresa" />
							</div>
							<hr />
							{
								esperandoCodigo
									? this.renderFormCodigo(bloqueado)
									: this.renderFormCredenciales(bloqueado)
							}
						</Col>
					</Row>
				</Container>
				<footer className="login-footer">
					<div className="float-right">© {moment().format('YYYY')}</div>
					<img src={logoParadigma} width={120} className="mx-2" alt="Logo Paradigma" />
				</footer>
			</div>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js